import GeneratorLayout from './GeneratorLayout/GeneratorLayout'
import GeneratorLayoutAdmin from './GeneratorLayoutAdmin/GeneratorLayoutAdmin'

export { GeneratorLayout, GeneratorLayoutAdmin }
